var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconChannel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 42 42",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-331.000000, -629.000000)",
    stroke: "#000000"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-7",
    transform: "translate(331.851852, 630.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 20.3148148,
    cy: 20.1666667,
    r: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 20.1481481,
    y1: 0,
    x2: 20.1481481,
    y2: 11.8518519,
    id: "Path-7"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path-9",
    points: "16.1481481 3.7037037 20.1481481 0 24.1481481 3.7037037"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 20.1481481,
    y1: 28.1481481,
    x2: 20.1481481,
    y2: 40,
    id: "Path-7",
    transform: "translate(20.148148, 34.074074) rotate(-180.000000) translate(-20.148148, -34.074074) "
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path-9",
    transform: "translate(20.148148, 38.148148) rotate(-180.000000) translate(-20.148148, -38.148148) ",
    points: "16.1481481 40 20.1481481 36.2962963 24.1481481 40"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 30.1000214,
    y1: 4.12220086,
    x2: 30.1000214,
    y2: 15.9740527,
    id: "Path-7",
    transform: "translate(30.100021, 10.048127) rotate(-315.000000) translate(-30.100021, -10.048127) "
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path-9",
    transform: "translate(32.980827, 7.167321) rotate(-315.000000) translate(-32.980827, -7.167321) ",
    points: "29.2771231 9.01917323 32.9808268 5.31546953 36.6845305 9.01917323"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 10.1962749,
    y1: 24.0259473,
    x2: 10.1962749,
    y2: 35.8777991,
    id: "Path-7",
    transform: "translate(10.196275, 29.951873) rotate(-495.000000) translate(-10.196275, -29.951873) "
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path-9",
    transform: "translate(7.315470, 32.832679) rotate(-495.000000) translate(-7.315470, -32.832679) ",
    points: "3.61176582 34.6845305 7.31546953 30.9808268 11.0191732 34.6845305"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 34.2222222,
    y1: 14.0740741,
    x2: 34.2222222,
    y2: 25.9259259,
    id: "Path-7",
    transform: "translate(34.222222, 20.000000) rotate(-270.000000) translate(-34.222222, -20.000000) "
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path-9",
    transform: "translate(38.296296, 20.000000) rotate(-270.000000) translate(-38.296296, -20.000000) ",
    points: "34.2962963 21.8518519 38.2962963 18.1481481 42.2962963 21.8518519"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6.07407407,
    y1: 14.0740741,
    x2: 6.07407407,
    y2: 25.9259259,
    id: "Path-7",
    transform: "translate(6.074074, 20.000000) rotate(-450.000000) translate(-6.074074, -20.000000) "
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path-9",
    transform: "translate(2.000000, 20.000000) rotate(-450.000000) translate(-2.000000, -20.000000) ",
    points: "-2 21.8518519 2 18.1481481 6 21.8518519"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 30.1000214,
    y1: 24.0259473,
    x2: 30.1000214,
    y2: 35.8777991,
    id: "Path-7",
    transform: "translate(30.100021, 29.951873) rotate(-225.000000) translate(-30.100021, -29.951873) "
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path-9",
    transform: "translate(32.980827, 32.832679) rotate(-225.000000) translate(-32.980827, -32.832679) ",
    points: "29.2771231 34.6845305 32.9808268 30.9808268 36.6845305 34.6845305"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 10.1962749,
    y1: 4.12220086,
    x2: 10.1962749,
    y2: 15.9740527,
    id: "Path-7",
    transform: "translate(10.196275, 10.048127) rotate(-405.000000) translate(-10.196275, -10.048127) "
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path-9",
    transform: "translate(7.315470, 7.167321) rotate(-405.000000) translate(-7.315470, -7.167321) ",
    points: "3.61176582 9.01917323 7.31546953 5.31546953 11.0191732 9.01917323"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconChannel);
export default __webpack_public_path__ + "static/media/icon-channel.3f5d2b35fee759186d0aa24530bad1a4.svg";
export { ForwardRef as ReactComponent };